
import React from 'react';
import './msg.scss';
export default class Message extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            flag: false,
            msg: this.props.msg
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.msg != this.state.msg) {
            this.setState({
                msg: nextProps.msg,
                flag: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        msg: "",
                        flag: false
                    })
                }, 2000)
            })
        }

    }
    render() {
        return (<div className={`pubilc_msg ${this.state.flag ? "" : "hide"}`}>
            {this.state.msg}
        </div>)
    }
}